import { render, staticRenderFns } from "./menuTree.vue?vue&type=template&id=d1c43442&"
import script from "./menuTree.vue?vue&type=script&lang=js&"
export * from "./menuTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports